export default __webpack_public_path__ + "static/media/uzh-pos-chain.2537a345.png";